export async function getRecentActivity() {
    let url = `/api/recent-activity`;
    // use fetch instead of axios
    const response = await fetch(url, {
        method: "GET",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
        },
    });
    return await response.json();
}

export async function updateUserEmail(payload: {
    email: string;
    alternate_email?: string | null;
}) {
    const response = await fetch("/api/user/email", {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error?.message || "Failed to update email");
    }

    return await response.json();
}
